import React from "react";
import { useParams } from "react-router-dom";
import AppLinkRedirect from "../components/AppLinkRedirect";
import {
  buildDeepLink,
  decodeAndValidatePublicId
} from "../utils/appLinks";

function AdRedirect() {
  const { adId: routeAdId = "" } = useParams();
  const adId = decodeAndValidatePublicId(routeAdId);

  return (
    <AppLinkRedirect
      deepLinkUrl={adId ? buildDeepLink("ad", adId) : null}
      invalid={!adId}
      openingTitle="Opening this ad in Mondoway..."
      invalidTitle="This ad link is invalid."
    />
  );
}

export default AdRedirect;
